
import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { bulidUid } from '@/libs/util.js'
import { Getter, Mutation } from 'vuex-class'
@Component
export default class ErmjTable extends Vue {
    //二人麻将
    table = {
        data: [],
        column: [
            {
                key: 'uid',
                title: '玩家ID',
                align: 'center',
                width: 110,
                render: (h, params) => {
                    let str = bulidUid(params.row.uid)
                    return h('div', [
                        h('p', str),
                        h(
                            'p',
                            {
                                style: {
                                    color: 'red'
                                }
                            },
                            String(params.row.uid).indexOf(String(params.row.user_id)) > -1 ? '(查询玩家)' : ''
                        )
                    ])
                }
            },
            {
                key: 'base_point',
                title: '底分',
                align: 'center',
                width: 50,
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.base_point))
                }
            },
            {
                key: 'length',
                title: '本局剩余牌数',
                align: 'center',
                width: 90,
                render: (h, params) => {
                    return h('span', params.row.left_cards)
                }
            },
            {
                key: 'WinType',
                title: '胡牌情况',
                align: 'center',
                width: 70,
                render: (h, params) => {
                    let str = ''
                    if (params.row.GunUid == 0) {
                        let arr = ['荒局', '自摸', '普通点炮', '抢杠胡']
                        str = params.row.uid == params.row.WinUid ? arr[params.row.WinType] : ''
                    } else {
                        str = params.row.uid == params.row.GunUid ? '点炮' : ''
                    }
                    return h('span', str)
                }
            },
            {
                key: 'Bet',
                title: '番数情况',
                align: 'center',
                width: 90,
                render: (h, params) => {
                    let str = ''
                    if (params.row.uid == params.row.WinUid) {
                        params.row.ermjDetaileWin.map((item) => {
                            str += item + '<br>'
                        })
                    }
                    return h('div', {
                        domProps: {
                            innerHTML: str
                        }
                    })
                }
            },
            {
                key: 'RealAWard',
                title: '输赢金额',
                align: 'center',
                width: 60,
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.RealAWard))
                }
            },
            {
                key: 'PercentPoint',
                title: '税收金额',
                align: 'center',
                width: 60,
                render: (h, params) => {
                    return h('span', (this as any).getMoney(params.row.data.PercentPoint))
                }
            },
            {
                key: 'banker',
                title: '游戏身份',
                align: 'center',
                width: 60,
                render: (h, params) => {
                    return h('span', params.row.uid == params.row.banker ? '庄' : '闲')
                }
            },
            {
                key: 'Bet',
                title: '牌面情况',
                width: 550,
                render: (h, params) => {
                    let arr = params.row.data.C || [] //剩余牌面
                    let arr2 = params.row.data.Flowers || [] //花色
                    let arr3 = params.row.data.SetCards || [] //吃/碰/杠牌数据
                    let dataArr: any = []
                    arr3.forEach((item, index) => {
                        let subArr = item.AllCards
                        let show = false
                        let red = item.Card
                        let one = true
                        subArr.forEach((subitem, subindex) => {
                            if (subitem == red && one) {
                                //显示红框
                                show = true
                                one = false
                                dataArr.push({ card: subitem, show: show, type: item.Type })
                            } else {
                                //不显示
                                show = false
                                dataArr.push({ card: subitem, show: show, type: item.Type })
                            }
                        })
                        if (index != arr3.length - 1) {
                            //间隔
                            dataArr.push({ card: '', show: '' })
                        }
                    })
                    return h('div', [
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: dataArr.map((x, index) => {
                                    let str = ''
                                    if (index == 0) {
                                        str = '<span style="margin-left:5px;">吃、碰、杠牌数据：</span>'
                                    }
                                    if (x.card != '') {
                                        if (x.show) {
                                            return str + "<img style='width:25px;color: #f92f26; border: 2px solid; border-radius: 6px;' src=img/poker/MJ/mingmah_" + (x.card + 10) + '.png>'
                                        } else {
                                            if (x.type == 6) {
                                                return str + "<img style='width:25px;' src=img/poker/MJ/mingmah_" + 0 + '.png>'
                                            }
                                            return str + "<img style='width:25px;' src=img/poker/MJ/mingmah_" + (x.card + 10) + '.png>'
                                        }
                                    } else {
                                        return '&nbsp;&nbsp;'
                                    }
                                })
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: arr2.map((x, index) => {
                                    let str = ''
                                    if (index == 0) {
                                        str = '<span style="margin-left:5px;">花牌：</span>'
                                    }
                                    return str + "<img style='width:25px;' src=img/poker/MJ/mingmah_" + (x + 10) + '.png>'
                                })
                            }
                        }),
                        h('div', {
                            style: {
                                marginTop: '5px'
                            },
                            domProps: {
                                innerHTML: arr.map((x, index) => {
                                    let str = ''
                                    if (index == 0) {
                                        str = '<span style="margin-left:5px;">手牌：</span>'
                                    }
                                    if (params.row.uid == params.row.WinUid) {
                                        if (index == arr.length - 1) {
                                            str = "<span style='margin-left: 20px;'>胡牌：</span>"
                                        }
                                    }
                                    return str + "<img style='width:25px;' src=img/poker/MJ/mingmah_" + (x + 10) + '.png>'
                                })
                            }
                        })
                    ])
                }
            }
        ]
    }
    getListData() {
        if (this.listdata[0].opt_detail == 'null') {
            return (this.table.data = [])
        } else {
            let obj3 = JSON.parse(this.listdata[0].opt_detail).users
            let list = JSON.parse(this.listdata[0].opt_detail)
            let arr3: any = []
            let arrlist = JSON.stringify(list.fan_details) === '{}' ? [] : list.fan_details[list.WinUid].Detail
            let arr4: any = []
            for (let i in arrlist) {
                arr4.push(this.getType(i) + arrlist[i] + '番')
            }
            for (let i in obj3) {
                let Object = {
                    user_id: this.listdata[0].user_id,
                    WinUid: list.WinUid, //谁胡了
                    base_point: list.base_point, //底分
                    WinType: list.WinType, //胡牌类型
                    banker: list.banker, //庄家UID
                    GunUid: list.GunUid, //点炮玩家（自摸0）
                    left_cards: list.left_cards == undefined ? '' : list.left_cards.length, //剩余牌数
                    uid: i,
                    data: obj3[i],
                    ermjDetaileWin: arr4
                }
                arr3.push(Object)
            }
            arr3.sort((a, b) => {
                return a.data.Rank - b.data.Rank
            })
            return arr3
        }
    }
    //二人麻将番型
    getType(num) {
        let ermjObj = {
            '1001': '大四喜',
            '1002': '大三元',
            '1003': '九莲宝灯',
            '1004': '四杠',
            '1005': '连七对',
            '1006': '天胡',
            '1007': '地胡',
            '1008': '人胡',
            '1009': '百万石',
            '1010': '小四喜',
            '1011': '小三元',
            '1012': '字一色',
            '1013': '四暗刻',
            '1014': '一色双龙会',
            '1015': '一色四同顺',
            '1016': '一色四节高',
            '1017': '一色四步高',
            '1018': '三杠',
            '1019': '混幺九',
            '1020': '七对',
            '1021': '清一色',
            '1022': '一色三同顺',
            '1023': '一色三节高',
            '1024': '清龙',
            '1025': '一色三步高',
            '1026': '三暗刻',
            '1027': '天听',
            '1028': '三风刻',
            '1029': '大于五',
            '1030': '小于五',
            '1031': '妙手回春',
            '1032': '海底捞月',
            '1033': '杠上开花',
            '1034': '抢杠胡',
            '1035': '碰碰胡',
            '1036': '混一色',
            '1037': '全求人',
            '1038': '双箭刻',
            '1039': '双暗杠',
            '1040': '全带幺',
            '1041': '不求人',
            '1042': '双明杠',
            '1043': '胡绝张',
            '1044': '立直',
            '1045': '箭刻',
            '1046': '门前清',
            '1047': '平胡',
            '1048': '四归一',
            '1049': '双暗刻',
            '1050': '断幺',
            '1051': '暗杠',
            '1052': '二五八将',
            '1053': '幺头九',
            '1054': '报听',
            '1055': '一般高',
            '1056': '连六',
            '1057': '老少副',
            '1058': '花牌',
            '1059': '幺九刻',
            '1060': '明杠',
            '1061': '边张',
            '1062': '坎张',
            '1063': '单吊将',
            '1064': '自摸'
        }
        return ermjObj[num]
    }

    @Prop()
    listdata
}
